import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { CommonMediaQueries, LetModule, MediaScreenService } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';

import { AuthStore } from '@pp/core/auth-store';
import { NotificationsComponent } from '@pp/notifications';

import { HeaderComponent } from './header/header.component';
import { MenuComponent } from './menu/menu.component';
import { ShellStore } from './shell.store';
import { SidebarComponent } from './sidebar/sidebar.component';

@Component({
  imports: [RouterOutlet, SidebarComponent, HeaderComponent, NotificationsComponent, MenuComponent, AsyncPipe, LetModule, TranslateModule],
  selector: 'pp-shell',
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellComponent {
  readonly #shellStore = inject(ShellStore);
  readonly #authStore = inject(AuthStore);
  readonly #mediaScreenService = inject(MediaScreenService);

  breakpoints$ = combineLatest({
    isTablet: this.#mediaScreenService.mediaMatcher(CommonMediaQueries.MD),
    isDesktop: this.#mediaScreenService.mediaMatcher(CommonMediaQueries.LG),
  });

  user = this.#authStore.user;
  i18Header = this.#shellStore.i18Header;
  headerData = computed(() => {
    return { title: this.i18Header(), user: this.user() };
  });
}
